import apiClient from "./apiClient";

export const getTransactions = async (params = {}) => {
  try {
    const { search = "", oemId = "", limit = 10, page = 1 } = params;
    const response = await apiClient.get("/partners/oem-partners/transactions/list", {
      params: { search, oemId, limit, page },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    throw error;
  }
};